import { StoreState } from "./index";

export function getIsLoadingLedgerContext(
  state: StoreState
): StoreState["isLedgerContextLoading"] {
  return state.isLedgerContextLoading;
}

export function getIsLoadingLedgerActivity(
  state: StoreState
): StoreState["isLedgerActivityLoading"] {
  return state.isLedgerActivityLoading;
}

export function getLedgerActivity(
  state: StoreState
): StoreState["ledgerActivity"] {
  return state.ledgerActivity;
}

export function getLedgerContext(
  state: StoreState
): StoreState["ledgerContext"] {
  return state.ledgerContext;
}

export function getTransactionId(
  state: StoreState
): StoreState["transactionId"] {
  return state.transactionId;
}

export function getIsLoadingPDPPointsTotal(
  state: StoreState
): StoreState["isPDPPointsTotalLoading"] {
  return state.isPDPPointsTotalLoading;
}

export function getPDPPointsTotal(
  state: StoreState
): StoreState["pdpPointsTotal"] {
  return state.pdpPointsTotal;
}

export function getIsLoadingLoyaltyQuestToken(
  state: StoreState
): StoreState["isLoyaltyQuestTokenLoading"] {
  return state.isLoyaltyQuestTokenLoading;
}

export function getLoyaltyQuestToken(
  state: StoreState
): StoreState["loyaltyQuestToken"] {
  return state.loyaltyQuestToken;
}
